import { render } from "./NewsDetail.vue?vue&type=template&id=dfaa1f72&scoped=true"
import script from "./NewsDetail.vue?vue&type=script&lang=ts"
export * from "./NewsDetail.vue?vue&type=script&lang=ts"

import "./NewsDetail.vue?vue&type=style&index=0&id=dfaa1f72&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dfaa1f72"

export default script